const getters = {
    getErrorMessage: (state, getters) => {
        return state.errorMessage;
    },
    getSuccessMessage: (state, getters) => {
        return state.successMessage;
    },
    getUserInfo: (state, getters) => {
        return state.userInfo;
    },
    getIdolInfo: (state, getters) => {
        return state.idolInfo;
    },
    getProperty: (state, getters) => {
        return state.property;
    },
    getScore: (state, getters) => {
        return state.score;
    },
    getProfit: (state, getters) => {
        return state.profit;
    },
    getNexus: (state, getters) => {
        return state.nexus;
    },

    getOpenid: (state, getters) => {
        return state.openid;
    },
    getSiteVersion: (state, getters) => {
        return state.version;
    },

    getPasswd: (state, getters) => {
        return state.passwd;
    },
    getIncomeRetail: (state, getters) => {
        return state.incomeRetail;
    },
    getTotalIncomeRetail: (state, getters) => {
        return state.incomeTotalRetail;
    },
    getIncomeTeam: (state, getters) => {
        return state.incomeTeam;
    },
    getTotalIncomeTeam: (state, getters) => {
        return state.incomeTotalTeam;
    },
    getWithDrawList: (state, getters) => {
        return state.withDrawList;
    },
    getNexusRetailLevelOverview: (state, getters) => {
        return state.nexusRetailLevelOverview;
    },
    getNexusRetailLevelUsersw: (state, getters) => {
        return state.nexusRetailLevelUsers;
    },
    getNexusTeamLevelOverview: (state, getters) => {
        return state.nexusTeamLevelOverview;
    },
    getNexusTeamLevelUsersw: (state, getters) => {
        return state.nexusTeamLevelUsers;
    },
    getFansList: (state, getters) => {
        return state.fansList;
    },
    getTopProfit: (state, getters) => {
        return state.topProfit;
    },
    getQrocodes: (state, getters) => {
        return state.qrocodes;
    },
    getChannel: (state, getters) => {
        return state.channel;
    },
    getChannelList: (state, getters) => {
        return state.channelList;
    },
    getFriendEnvPoster: (state, getters) => {
        return state.friendEnvPoster;
    },
    getFriendPoster: (state, getters) => {
        return state.friendPoster;
    },
    getOwnRank: (state, getters) => {
        return state.ownRank;
    },
    getFans: (state, getters) => {
        return state.fans;
    },
    getFansSummary: (state, getters) => {
        return state.fansSummary;
    },
    getLoginConfig: (state, getters) => {
        return state.loginConfig;
    },
    getLoginCode: (state, getters) => {
        return state.getLoginCode;
    },
    login: (state, getters) => {
        return state.login;
    },
    getUserRightCode: (state, getters) => {
        return state.rightCode;
    },
  getMemberLevelList: state => {
        return state.memberLevelList;
    },
};

export default getters;



// WEBPACK FOOTER //
// ./src/getters/user.js